module.exports = {"320509001":"松陵街道","320509002":"横扇街道","320509003":"八坼街道","320509004":"江陵街道","320509104":"平望镇","320509105":"盛泽镇","320509107":"七都镇","320509108":"震泽镇","320509109":"桃源镇","320509110":"黎里镇","320509111":"同里镇","320509400":"吴江经济技术开发区","320509401":"东方丝绸市场","320509402":"东太湖生态旅游度假区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320509.json
// module id = 967
// module chunks = 0